
import '../css/App.css';
import '../css/Login.css';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AuthForm from '../auth/AuthForm'
import ResetPassword from '../auth/ResetPassword';
import { AuthProvider } from '../auth/AuthContext';
import PrivateRoute from '../auth/PrivateRoute'
import Layout from '../common/AppLayout';
import Home from '../components/Home'
import NoticeDetails from '../components/NoticeDetails';
import FileUpload from '../components/UploadFile'
import NoticeList from '../components/NoticeList';
import Loader from '../common/Loader';
import { setLoaderController } from '../helper/LoaderUtility';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from 'react-toastify';


const App = () => {
  const [isLoaderVisible, setLoaderVisible] = useState(false);

  // Use a side effect to update loader visibility
  useEffect(() => {
    const handleVisibilityChange = (isVisible) => {
      setLoaderVisible(isVisible);
    };

    setLoaderController(handleVisibilityChange);

    return () => {
      setLoaderController(() => { }); // Clean up
    };
  }, []);

  return (
    <>
      <Loader isVisible={isLoaderVisible} />
      <div className="app">
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="/login" element={<AuthForm />} />
              <Route path="/reset-password/:key" element={<ResetPassword />} />
              <Route path="/" element={<PrivateRoute element={<Layout />} />}>
                <Route path="home" element={<PrivateRoute element={<Home />} />} />
                <Route path="noticeList/:key" element={<PrivateRoute element={<NoticeList />} />} />
                <Route path="noticeList" element={<PrivateRoute element={<NoticeList />} />} />
                <Route path="upload" element={<PrivateRoute element={<FileUpload />} />} />
                <Route path="noticeDetails/:id" element={<PrivateRoute element={<NoticeDetails />} />} />
              </Route>
              <Route path='*' element={<div>Not found</div>} />
            </Routes>
          </Router>
        </AuthProvider>
        {/* <div>
          <ToastContainer></ToastContainer>
        </div> */}
      </div>
    </>
  );
};

// export default App;

// function App() {
//   return (
//     <div className="app">
//       <AuthProvider>
//         <Router>
//           <Routes>
//             <Route path="/" element={<Navigate to="/login" />} />
//             <Route path="/login" element={<AuthForm />} />
//             <Route path="/" element={<PrivateRoute element={<Layout />} />}>
//               <Route path="home" element={<PrivateRoute element={<Home />} />} />
//               <Route path="upload" element={<PrivateRoute element={<FileUpload />} />} />
//             </Route>
//             <Route path='*' element={<div>Not found</div>} />
//           </Routes>
//         </Router>
//       </AuthProvider>
//     </div>
//   );
// }

export default App;
